import type { GraphQLQuery } from "@aws-amplify/api";
import { getEaLogger, setSessionDetails } from "../../state";
import { getClient } from "../client";
import { type EventType, type UpdateExpertMutation, updateExpert } from "./mutations";

export async function handleExpertUpdate(employeeId: string, eventType: EventType) {
    try {
        const result = await getClient().graphql<GraphQLQuery<UpdateExpertMutation>>({
            query: updateExpert,
            variables: { input: { employeeId, eventType } },
        });

        const expert = result.data.updateExpert;
        if (expert) {
            setSessionDetails(expert.sessionId, expert.callSid, expert.partner);
        }
    } catch (error: unknown) {
        getEaLogger().warn({ error, module: "updateExpert" }, "An error occurred during expertUpdate mutation");
    }
}
